import pageheader from "../../../pageheader";
import { mapGetters } from "vuex";
import utils from "../../../../utils/util";
import alertService from "../../../../api/alertConfiguration.service";
import telematicsService from "../../../../api/telematics.service";
import moment from "moment";

function createEmptyLeg() {
  return {
    eventId: null,
    eventDescription: null,
    thresholdDataType: null,
    eventLabel: null,
    operator: null,
    thresholdValue: null,
    units: "",
    minValue: 0,
    maxValue: 0,
    selectionList: [],
    selectedSelection: null,
    allLocationSelected: false,
    selectedBooleanOption: null,
    showFields: false,
  };
}

export default {
  components: { pageheader },

  props: {
    isPermissionOn: {
      type: Boolean,
    },
  },
  data() {
    return {
      isAlertLoading: false,
      alertName: null,
      eventList: [],
      editing: false,
      logicalOperator: "ALL",
      eventLegs: [createEmptyLeg()],
      operatorsList: [
        { name: "is less than (<)", value: "<" },
        { name: "is less than or equal to (<=)", value: "<=" },
        { name: "is greater than (>)", value: ">" },
        { name: "is greater than or equal to (>=)", value: ">=" },
        { name: "is equal to (=)", value: "=" },
      ],
      criticality: null,
      valid: false,
      selectedMappingFilter: null,
      selectedEquipments: [],
      selectedGroups: [],
      selectedJobsites: [],
      selectedCategories: [],
      selectedModels: [],
      showEquipDialog: false,

      equipmentLoader: false,
      headers: [
        { text: "Equipment #", value: "stockKey" },
        { text: "Description", value: "description" },
        { text: "Serial #", value: "serialNo" },
        { text: "Make", value: "brand" },
        { text: "Model", value: "model" },
        { text: "Category", value: "category" },
        { text: "", value: "data-table-select" },
      ],
      equipmentsList: [],
      totalRecordsCount: 0,
      pageSize: 100,
      search: "",
      makes: [],
      makesCopy: [],
      models: [],
      modelsCopy: [],
      selectedSerialMachineVin: "",
      selectedMake: [],
      selectedModel: [],
      makeSearchTerm: "",
      modelSearchTerm: "",
      makeSearchFilter: "",
      modelSearchFilter: "",
      selectedEquipmentsChecked: [],
      savedAssetValues: [],
      equipmentCheckedLoaded: false,
      assignKey: 0,
      endDate: null,
      startDate: this.formatDate(new Date()),
      groups: [],
      options: {},
      jobSites: [],
      categories: [],
      modelsList: [],
      referenceFieldValueshow: [],
      pageNumber: 1,
      input: {},
      jobsiteLoader: false,
      menu1: false,
      enableServerSidePagination: false,
      sortingBy: "stockKey",
      sortOrder: true,
    };
  },
  computed: {
    ...mapGetters(["roles"]),
    canAddLeg() {
      return this.eventLegs.length < 5;
    },
    isConfigValid() {
      if (!this.alertName || !this.criticality || !this.startDate) return false;
      if (!this.eventLegs.length || !this.eventLegs[0].eventId) return false;
      for (const leg of this.eventLegs) {
        if (!leg.eventId || !leg.showFields) return false;
        if (
          leg.thresholdDataType === "Number" &&
          (!leg.operator ||
            leg.thresholdValue === null ||
            leg.thresholdValue === "")
        )
          return false;
        if (leg.thresholdDataType === "Boolean" && !leg.selectedBooleanOption)
          return false;
        // Selection (e.g. location/geofence) is required unless "All" is chosen
        if (
          leg.thresholdDataType === "Selection" &&
          !leg.allLocationSelected &&
          !leg.selectedSelection
        )
          return false;
        // SelectionWithOperator needs both operator and a chosen value
        if (
          leg.thresholdDataType === "SelectionWithOperator" &&
          (!leg.operator ||
            leg.thresholdValue === null ||
            leg.thresholdValue === "")
        )
          return false;
      }
      if (!this.selectedMappingFilter) return false;
      if (this.selectedMappingFilter !== "AllAssets") {
        const hasScope =
          this.selectedEquipments.length > 0 ||
          this.selectedGroups.length > 0 ||
          this.selectedJobsites.length > 0 ||
          this.selectedCategories.length > 0 ||
          this.selectedModels.length > 0;
        if (!hasScope) return false;
      }
      return true;
    },
  },

  watch: {
    selectedMappingFilter(newValue) {
      if (newValue === "Jobsite") this.getJobsites();
      else if (newValue === "Group") this.getGroups();
      else if (newValue === "Category") this.getCategories();
      else if (newValue === "Model") this.getModelsList();
      this.emitConfig();
    },

    alertName() {
      this.emitConfig();
    },
    criticality() {
      this.emitConfig();
    },
    startDate() {
      this.emitConfig();
    },
    logicalOperator() {
      this.emitConfig();
    },
    selectedJobsites: {
      handler() {
        this.emitConfig();
      },
      deep: true,
    },
    selectedGroups: {
      handler() {
        this.emitConfig();
      },
      deep: true,
    },
    selectedCategories: {
      handler() {
        this.emitConfig();
      },
      deep: true,
    },
    selectedModels: {
      handler() {
        this.emitConfig();
      },
      deep: true,
    },
    eventLegs: {
      handler() {
        this.emitConfig();
      },
      deep: true,
    },
    isConfigValid: {
      handler(valid) {
        this.$emit("validityChanged", valid);
      },
      immediate: true,
    },

    selectedEquipments: {
      handler() {
        this.validateCheckedItems();
        this.emitConfig();
      },
      deep: true,
    },

    options: {
      handler(event) {
        this.paginate(event);
      },
      deep: true,
    },
  },
  async mounted() {
    this.input = utils.getInputContent("alertconfiguration", this.roles);
    if ("id" in this.$route.params) {
      this.isAlertLoading = true;
      this.editing = true;
      await this.getAlertDetailsById(this.$route.params.id);
    } else {
      this.editing = false;
    }
    await this.getEvents();
    this.isAlertLoading = false;
  },
  filters: {
    formatDates: function (value) {
      if (value) {
        return moment(value).format("MM/DD/YYYY");
      }
      return "";
    },
  },
  methods: {
    formatDate(value) {
      if (value) {
        return moment(value).format("YYYY-MM-DD");
      }
    },

    disablePastDates(val) {
      return val >= new Date().toISOString().substr(0, 10);
    },

    // ── Event Legs ──────────────────────────────────────────────
    addEventLeg() {
      if (this.eventLegs.length < 5) {
        this.eventLegs.push(createEmptyLeg());
      }
    },

    removeEventLeg(index) {
      if (this.eventLegs.length > 1) {
        this.eventLegs.splice(index, 1);
      }
    },

    async onEventChange(legIndex, eventId) {
      const leg = this.eventLegs[legIndex];
      leg.eventId = eventId;
      leg.showFields = false;
      leg.operator = null;
      leg.thresholdValue = null;
      leg.selectedSelection = null;
      leg.selectedBooleanOption = null;
      leg.selectionList = [];

      try {
        const response = await alertService.getEventDetails(eventId);
        if (response && response.data) {
          leg.eventDescription = response.data.description;
          const config = response.data.configuration;
          leg.thresholdDataType = config.type;
          leg.eventLabel = config.label;
          leg.showFields = true;

          if (config.type === "Number") {
            leg.units = config.units || "";
            leg.minValue = config.minValue || 0;
            leg.maxValue = config.maxValue || 0;
          } else if (config.type === "Selection") {
            await this.fetchGeoFencesForLeg(legIndex);
          } else if (config.type === "SelectionWithOperator") {
            leg.selectionList = config.selectionValues || [];
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    async fetchGeoFencesForLeg(legIndex) {
      const response = await telematicsService.getGeofences();
      if (response && response.data) {
        this.eventLegs[legIndex].selectionList = response.data.map((gf) => ({
          key: gf.id,
          value: gf.name,
        }));
      }
    },

    // ── Scope data loaders ──────────────────────────────────────
    async getCategories() {
      this.categories = [];
      try {
        let response = await telematicsService.getCategoriesSearch("");
        if (response && response.data) {
          this.categories = response.data.map((c) =>
            typeof c === "string" ? { name: c } : c,
          );
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getModelsList() {
      this.modelsList = [];
      try {
        let response = await telematicsService.getModels();
        if (response && response.data) {
          this.modelsList = response.data.map((m) =>
            typeof m === "string" ? { name: m } : m,
          );
        }
      } catch (err) {
        console.log(err);
      }
    },

    // ── Existing methods (kept) ─────────────────────────────────
    clearAssetFilters(i) {
      try {
        this.selectedEquipments = this.selectedEquipments.filter(
          (e) => e.fleetId != i.fleetId,
        );
        this.selectedEquipmentsChecked = this.selectedEquipments;
      } catch (error) {
        console.log(`remove asset error :- ${error}`);
      }
    },

    handleCancel() {
      this.$router.push({ path: "/alert-configuration/list" });
    },

    closeDialog() {
      this.showEquipDialog = false;
    },

    paginate({ page, itemsPerPage, sortBy, sortDesc }) {
      if (this.enableServerSidePagination) {
        if (sortBy[0]) {
          this.sortingBy = sortBy[0];
          this.sortOrder = sortDesc[0];
        } else {
          this.sortingBy = "stockKey";
          this.sortOrder = true;
        }
        this.getEquipments(page, itemsPerPage);
      }
    },

    validateCheckedItems() {
      this.selectedEquipmentsChecked = this.selectedEquipments;
    },

    resetSerialMachineVin() {
      this.selectedSerialMachineVin = "";
      this.getEquipments();
    },

    clearFilters() {
      this.selectedMake = [];
      this.selectedSerialMachineVin = "";
      this.selectedModel = [];
      this.getEquipments();
    },

    async getEquipments(pageNo = 1, itemsPerPage = 100) {
      this.equipmentLoader = true;
      this.equipmentsList = [];
      try {
        let response = await telematicsService.getFleetsInAlerts(
          this.selectedSerialMachineVin || "",
          this.selectedModel ? this.selectedModel.join(",") : [],
          this.selectedMake ? this.selectedMake.join(",") : "",
          pageNo,
          itemsPerPage,
          this.sortingBy,
          this.sortOrder,
        );
        if (response.data) {
          this.equipmentLoader = false;
          // BE-1107: the source collection is contract-grained (one row per
          // asset-contract pair), so a unit on N contracts arrives N times.
          // Collapse to one row per telematics unit for the picker. The key
          // includes stockKey so a unit id reassigned in POR against a stale
          // line item cannot collapse two different machines into one; contract
          // rows for the same unit share a stockKey, so the collapse still
          // happens. dedupeBy passes rows with an empty key through untouched.
          // BE-1116: the alert cache (i5-cp-alerts-api jobs/v1.0.17 AlertCacheBuilderService.cs:348-359) matches Asset scope by FleetId only, so a
          // row without a fleetId is disabled rather than saved under a value
          // that can never match.
          this.equipmentsList = utils.dedupeBy(response.data, (e) =>
            e.tuUnitId ? `${e.tuUnitId}|${e.stockKey}` : ""
          ).map((e) => ({ ...e, isSelectable: Boolean(e.fleetId) }));
          // totalRecords is deliberately NOT reduced by this page's duplicates:
          // it drives the server-side page count, and lowering it would make
          // the last page unreachable. The footer counts contract rows, not units.
          this.totalRecordsCount = response.totalRecords;
        } else {
          this.equipmentLoader = false;
          this.equipmentsList = [];
        }
      } catch (err) {
        console.log(err);
        this.equipmentLoader = false;
      }
    },

    async filterValues() {
      try {
        await Promise.all([this.getMakes(), this.getModelsFilter()]);
      } catch (error) {
        console.log(`filterValues error :- ${error}`);
      }
      this.enableServerSidePagination = true;
      this.equipmentLoader = true;
      await this.getEquipments();
    },

    async getModelsFilter() {
      this.models = [];
      try {
        let response = await telematicsService.getModels();
        if (response) {
          this.models = response.data?.map((model) => ({ name: model }));
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getMakes() {
      this.makes = [];
      try {
        let response = await telematicsService.getBrands();
        if (response) {
          this.makes = response.data?.map((make) => ({ name: make }));
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getEvents() {
      try {
        const response = await alertService.fetchEvents();
        if (response && response.data) {
          this.eventList = response.data;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getJobsites() {
      this.jobsiteLoader = true;
      this.jobSites = [];
      try {
        let response = await telematicsService.getLocations();
        if (response && response.data) {
          this.jobSites = response.data;
          this.jobsiteLoader = false;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getGroups() {
      this.groups = [];
      try {
        let response = await telematicsService.getGroups();
        if (response && response.data) {
          this.groups = response.data;
        }
      } catch (err) {
        console.log(err);
      }
    },

    async getEquipmentsSelected() {
      try {
        let alert_id = this.$route.params.id || null;
        if (!alert_id) return;
        this.equipmentCheckedLoaded = true;
        let rows = [];
        if (this.savedAssetValues.length) {
          try {
            let response = await telematicsService.getTelematicAssetsByFleetIds(
              this.savedAssetValues,
            );
            if (response && response.isSuccess && response.data) {
              rows = response.data;
            }
          } catch (err) {
            console.log(err);
          }
        }
        // Saved values that do not resolve stay selected as placeholders, so
        // saving without changes writes back the same values.
        const selected = utils.buildSelectedEquipments(
          this.savedAssetValues,
          rows,
        );
        this.selectedEquipments = selected;
        this.selectedEquipmentsChecked = selected;
        this.equipmentCheckedLoaded = false;
      } catch (err) {
        console.log(err);
        this.equipmentCheckedLoaded = false;
      }
    },

    assignEquipment() {
      this.assignKey++;
      this.showEquipDialog = true;
      this.filterValues();
    },

    // ── Load alert for edit ─────────────────────────────────────
    async getAlertDetailsById(alertConfigId) {
      try {
        const response = await alertService.getAlertDetailsById(alertConfigId);
        if (response && response.data) {
          const d = response.data;
          this.$emit("navigateToAlertPreferenceWithObj", d);

          this.alertName = d.alertName;
          this.startDate = d.startDate ? this.formatDate(d.startDate) : null;
          this.endDate = d.endDate;
          this.criticality = d.criticality;
          this.logicalOperator = d.logicalOperator || "ALL";

          // Parse multi-leg: eventId is comma-separated, configurationData is array
          const eventIds = d.eventId ? d.eventId.split(",") : [];
          const configData = Array.isArray(d.configurationData)
            ? d.configurationData
            : d.configurationData
            ? [d.configurationData]
            : [];

          this.eventLegs = [];
          for (
            let i = 0;
            i < Math.max(eventIds.length, configData.length, 1);
            i++
          ) {
            const leg = createEmptyLeg();
            const eid = eventIds[i] || (configData[i] && configData[i].eventId);
            const cd = configData[i] || {};

            if (eid) {
              leg.eventId = eid;
              leg.thresholdDataType = cd.thresholdDataType || null;
              leg.operator = cd.operator || null;
              leg.units = cd.units || "";

              // Fetch event details for this leg
              try {
                const evtResp = await alertService.getEventDetails(eid);
                if (evtResp && evtResp.data) {
                  leg.eventDescription = evtResp.data.description;
                  const config = evtResp.data.configuration;
                  leg.eventLabel = config.label;
                  leg.showFields = true;
                  if (config.type === "Number") {
                    leg.minValue = config.minValue || 0;
                    leg.maxValue = config.maxValue || 0;
                    leg.units = config.units || leg.units;
                    leg.thresholdValue = cd.thresholdValue;
                  } else if (config.type === "Selection") {
                    leg.thresholdDataType = "Selection";
                    if (cd.thresholdValue === "All") {
                      leg.allLocationSelected = true;
                      leg.selectedSelection = "All";
                    } else {
                      leg.selectedSelection = cd.thresholdValue;
                    }
                  } else if (config.type === "Boolean") {
                    leg.selectedBooleanOption =
                      typeof cd.thresholdValue === "string"
                        ? cd.thresholdValue
                        : cd.thresholdValue != null
                        ? String(cd.thresholdValue)
                        : null;
                  } else if (config.type === "SelectionWithOperator") {
                    leg.selectionList = config.selectionValues || [];
                    leg.thresholdValue = cd.thresholdValue;
                  }
                }
              } catch (err) {
                console.log(`Failed to load event details for ${eid}`, err);
                leg.showFields = true;
              }
            }
            this.eventLegs.push(leg);
          }

          // Handle geofence lists for Selection legs (re-fetch after legs array is built)
          for (let i = 0; i < this.eventLegs.length; i++) {
            if (
              this.eventLegs[i].thresholdDataType === "Selection" &&
              this.eventLegs[i].selectionList.length === 0
            ) {
              await this.fetchGeoFencesForLeg(i);
            }
          }

          // Scope
          this.savedAssetValues =
            d.referenceFieldName === "Asset" &&
            Array.isArray(d.referenceFieldValue)
              ? d.referenceFieldValue
              : [];
          this.selectedMappingFilter = d.referenceFieldName;
          switch (this.selectedMappingFilter) {
            case "Asset":
              await this.getEquipmentsSelected();
              this.referenceFieldValueshow = this.selectedEquipmentsChecked;
              break;
            case "Jobsite":
              this.selectedJobsites = d.referenceFieldValue || [];
              break;
            case "Group":
              this.selectedGroups = d.referenceFieldValue || [];
              break;
            case "Category":
              this.selectedCategories = d.referenceFieldValue || [];
              break;
            case "Model":
              this.selectedModels = d.referenceFieldValue || [];
              break;
          }
        }
      } catch (error) {
        this.$toast.error(error);
      }
    },

    // ── Build save object ───────────────────────────────────────
    buildSaveObj() {
      const eventIds = this.eventLegs
        .filter((l) => l.eventId)
        .map((l) => l.eventId)
        .join(",");

      const configurationData = this.eventLegs
        .filter((l) => l.eventId)
        .map((leg) => ({
          eventId: leg.eventId,
          thresholdDataType: leg.thresholdDataType,
          thresholdValue:
            leg.thresholdDataType === "Number"
              ? leg.thresholdValue
              : leg.thresholdDataType === "Boolean"
              ? leg.selectedBooleanOption
                ? leg.selectedBooleanOption.toString()
                : ""
              : leg.thresholdDataType === "Selection"
              ? leg.selectedSelection
              : leg.thresholdDataType === "SelectionWithOperator"
              ? leg.thresholdValue
              : "",
          operator: leg.operator,
          units: leg.thresholdDataType === "Number" ? leg.units : "",
        }));

      let referenceFieldValue = [];
      switch (this.selectedMappingFilter) {
        case "Jobsite":
          referenceFieldValue = this.selectedJobsites;
          break;
        case "Group":
          referenceFieldValue = this.selectedGroups;
          break;
        case "Asset":
          referenceFieldValue = this.selectedEquipments.length
            ? this.selectedEquipments.map((e) => e.fleetId || e.stockKey)
            : [];
          break;
        case "Category":
          referenceFieldValue = this.selectedCategories;
          break;
        case "Model":
          referenceFieldValue = this.selectedModels;
          break;
      }

      return {
        eventId: eventIds,
        alertName: this.alertName,
        criticality: this.criticality,
        logicalOperator:
          this.eventLegs.length > 1 ? this.logicalOperator : null,
        startDate: this.startDate,
        endDate: this.endDate,
        enabled: true,
        referenceFieldName: this.selectedMappingFilter,
        referenceFieldValue: referenceFieldValue,
        configurationData: configurationData,
      };
    },

    emitConfig() {
      this.$emit("configUpdated", this.buildSaveObj());
    },
  },
};
